export default ({ beforeRequest }) => {
  beforeRequest.push(fetchOpts => {
    let newBody;
    try {
      if (fetchOpts.body instanceof FormData) {
        newBody = JSON.parse(fetchOpts.body.get('operations'));
      } else {
        newBody = JSON.parse(fetchOpts.body);
      }
    } catch {
      return;
    }
    if (newBody.variables) {
      removeUnderscoredProperties(newBody.variables);
      if (fetchOpts.body instanceof FormData) {
        fetchOpts.body.set('operations', JSON.stringify(newBody));
      } else {
        fetchOpts.body = JSON.stringify(newBody);
      }
    }
  });
};

function removeUnderscoredProperties (obj) {
  Object.keys(obj).forEach(key => {
    if (obj[key] && typeof obj[key] === 'object') { removeUnderscoredProperties(obj[key]); }
    if (key.charAt(0) === '_') delete obj[key];
  });
}
